// eslint-disable-next-line simple-import-sort/imports
import './polyfills';
import './utils/native-binding';
import './utils/debug-auth'; // DEV-only: exposes window.debugAuth for testing auth flows
import './services/api-interceptors';

import { StrictMode } from 'react';

import { createRoot } from 'react-dom/client';

import '@cfa/react-components/dist/styles.min.css';
import './styles/cfa-design-system-override.css';
import './styles/index.css';

import { Provider } from 'jotai';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import App from './app/App';
import { store as jotaiStore } from './atoms';
import {
  asyncWithLDProvider,
  basicLogger,
} from 'launchdarkly-react-client-sdk';

import Constants from './constants';

(async () => {
  const launchDarklyClientId = Constants.LAUNCH_DARKLY_CLIENT_ID;
  if (!launchDarklyClientId) {
    throw new Error('Missing LaunchDarkly client ID');
  }

  const LDProvider = await asyncWithLDProvider({
    clientSideID: launchDarklyClientId,
    context: { kind: 'user', key: 'anonymous' },
    options: {
      logger: basicLogger({ level: 'warn' }),
      evaluationReasons: true,
    },
  });

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Root element not found');
  }

  createRoot(rootElement).render(
    <LDProvider>
      <StrictMode>
        <Provider store={jotaiStore}>
          <NuqsAdapter>
            <App />
          </NuqsAdapter>
        </Provider>
      </StrictMode>
    </LDProvider>,
  );
})();
